var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.383 1.38365C10.272 1.29708 10.1354 1.25006 9.99463 1.25006C9.85391 1.25006 9.71723 1.29708 9.60629 1.38365L2.5 6.93942L2.50029 8.51309V16.25C2.50097 16.5813 2.63288 16.8989 2.86715 17.1332C3.10143 17.3674 3.41898 17.4993 3.75029 17.5H16.2503C16.5816 17.4994 16.8992 17.3675 17.1335 17.1332C17.3678 16.8989 17.4997 16.5814 17.5003 16.25V8.51877V6.9303L10.383 1.38365ZM11.2503 16.25H8.75029V11.25H11.2503V16.25ZM12.5003 16.25V11.25C12.4999 10.9186 12.3681 10.6009 12.1338 10.3666C11.8994 10.1322 11.5817 10.0004 11.2503 10H8.75029C8.41887 10.0004 8.10112 10.1322 7.86677 10.3665C7.63242 10.6009 7.50062 10.9186 7.50029 11.25V16.25H3.75029V7.53846L10.0003 2.66971L16.2503 7.54502V16.25H12.5003Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bd3dcae3ad6c5b0ba642bd3bb59d3889.svg";
export { ForwardRef as ReactComponent };